import React from "react";

import CheckboxGroup from "../../../components/CheckboxGroup";
import PageTitle from "../../../components/PageTitle";
import Question from "../../../components/Question";
import QuestionAddress from "../../../components/QuestionAddress";
import { default as QuestionFrame } from "../../../components/QuestionsFrame";
import RadioGroup from "../../../components/RadioGroup";
import Info from "../../../components/Info";

const Respondent: React.FC = () => {
  return (
    <>
      <PageTitle
        heading="Respondent Details"
        description={
          <>
            <>
              The respondent is the person who used {" "}
              <Info className="wideInfo"
                inherit
                string="family violence|Family violence|Family violence is harmful behaviour that is used to control, threaten, force or dominate a family member through fear. It includes: physically hurting or threatening a person, raping or sexually pressuring a family member, harming a person emotionally or psychologically, intentionally damaging property, controlling what a person can do, controlling how a family member uses money, harming or threatening to harm a pet/animal, publishing content online materials about you or threatening to do so without your permission, keeping you under observation or surveillance or using tracking or location devices to monitor you, misusing systems or services against you, or pressuring service providers to influence decisions about you, and stalking you."
              /> 
              {" "} against you and/or the protected person.
            </>
            <p>
              We need some information about the respondent so we can locate the
              original intervention order and serve them with the application.
              We will contact you before we serve the application on the
              respondent. You can contact us if you are concerned about your
              safety.
            </p>
          </>
        }
      />
      <QuestionFrame>
        <Question name="resp_det_giv_nam" />
        <Question name="resp_det_fam_nam" />
        <Question name="resp_det_other_names" />
        <RadioGroup
          name="resp_addr_known"
          optionChildren={{
            unknown: (
              <RadioGroup
                name="resp_addr_known_pc"
                optionChildren={{
                  yes: (
                    <>
                      <Question name="resp_addr_known_pc_stn" />
                      <Question name="resp_addr_known_pc_ofc" />
                    </>
                  ),
                }}
              />
            ),
            address: (
              <QuestionAddress
                label="Enter respondent's address"
                namePrefix="resp_det_addr"
              />
            ),
          }}
        />
        <CheckboxGroup
          name="resp_cont"
          optionChildren={{
            phone: (
              <>
                <Question name="resp_cont_phone_3" />
                <Question name="resp_cont_phone" />
                <Question name="resp_cont_phone_2" />
              </>
            ),
            email: (
              <>
                <Question name="resp_cont_email" />
              </>
            ),
            other: (
              <>
                <Question name="resp_cont_other" />
              </>
            ),
          }}
        />
        <RadioGroup name="resp_weapon_access" />
      </QuestionFrame>
    </>
  );
};

export default Respondent;
